import { createApp } from "vue";
import App from "./App.vue";
import "@/assets/styles/tailwind.css";
import "@/assets/styles/markdown.css";
import router from "@/router/router";
import { setupApp } from "@/utils/appSetup";

const app = createApp(App);

// Perform app-level setups (ElementPlus, ResizeObserver)
setupApp(app);

app.use(router);

// app-level error handling
app.config.errorHandler = (err: unknown) => {
  // eslint-disable-next-line no-console
  console.error(err);
};

app.mount("#app");
